import React, { FC, useEffect, useMemo } from "react";
import { useStore } from "effector-react";
import { PersonTypesCard } from "../../../cards";
import {
  $selectedPersonTypes,
  selectedPersonTypesApi,
} from "../../../store/selected/selectedPersonTypes";
import { PersonTypesEndpoint } from "../../../store/endpoints";
import { Skeleton } from "../../../components";
import { $selectedLocation } from "../../../store/selected/selectedLocations";
import { useTranslation } from "react-i18next";
import { AppConfig } from "../../../config";

const Locations: FC = () => {
  const { t, i18n } = useTranslation(AppConfig.translationFileNames.step_Main);
  const { data: personTypes, pending } = useStore(
    PersonTypesEndpoint.list.store
  );
  const selectedPersonTypes = useStore($selectedPersonTypes);
  const selectedLocation = useStore($selectedLocation);

  const { onChange } = selectedPersonTypesApi;

  useEffect(() => {
    if (selectedLocation) {
      PersonTypesEndpoint.list.call({
        _query: {
          page: 1,
          per_page: 99999,
          location_id: selectedLocation.id,
          lang: i18n.language,
        },
      });
    }
  }, [selectedLocation, i18n.language]);

  const displayData = useMemo(() => {
    return personTypes?.data.map((i) => {
      const idx = selectedPersonTypes.findIndex(({ id }) => id === i.id);
      if (~idx) {
        return { ...i, quantity: selectedPersonTypes[idx].quantity };
      }
      return { ...i, quantity: 0 };
    });
  }, [personTypes, selectedPersonTypes]);

  const active = useMemo(() => {
    return displayData && displayData.length > 0 && selectedLocation;
  }, [displayData, selectedLocation]);

  return (
    <>
      <h2 style={active ? {} : { opacity: 0.5 }}>{t("Guests")}</h2>
      {pending ? (
        <PreloadingSkeleton />
      ) : active ? (
        <PersonTypesCard min={1} value={displayData} onChange={onChange} />
      ) : null}
    </>
  );
};

export default Locations;

const PreloadingSkeleton: FC = () => <Skeleton height={140} width={300} />;
